import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import logo from "../components/themeimg/INWI_LOGO.png"
import { baseUrl, data, getHeaders } from '../config/config';
import Loader from './Loader';
import './style/scoreboard.css'
import backArrow from "./themeimg/dtLite/back_menu_arrow.png"
import backgroundImage from "./themeimg/dtLite/page_bg_image.jpg"
import bg from "./themeimg/dtLite/leaderbord_bg.png"
import rankIcon from "./themeimg/dtLite/rank_icon.png"
import position1 from "./themeimg/dtLite/leaderboard_1_position.png"
import position2 from "./themeimg/dtLite/leaderboard_2_position.png"
import position3 from "./themeimg/dtLite/leaderboard_3_position.png"
import crown from "./themeimg/dtLite/leaderboard_crown.png"
import nodata from "./themeimg/dtLite/no_leaderboard_icon.png"


export default function Scoreboard({ }) {

    const [sbData, setSbData] = useState([])
    const [loader, setLoader] = useState(false)
    const [type,setType] = useState("daily")
    const [status,setStatus] = useState()
    // var baseUrl = "http://dev.dreamtravelapp.in/api/";
    const navigate = useNavigate()
    var header = sessionStorage.getItem("header");
    const uid = localStorage.getItem("uid")
    const msisdn = localStorage.getItem("msisdn") ? localStorage.getItem("msisdn") : localStorage.getItem("msisdn2")
 {/* below code is to check navigate state pass between routes */}

    // const {state} = useLocation()

    // const {loader: value} = state;

    // console.log("value", value)

    console.log("sbdata",sbData)

        function changeToStar(num) {
        const temp = num.split('')
        for (let i = 6; i < temp.length; i++) {
            temp[i] = "X"
        }
        let ans = temp.join('')

        return ans


    }




    const gotoHome = () => {
        navigate('/home');
    }

    

    const scoreBoard = async () => {
        setLoader(true)
        const response = await axios({
            method: 'post',
            url: baseUrl + 'topScore',
            data:{"view_type":type},
            headers: getHeaders(),
        })

        setSbData(response?.data)
        setStatus(response?.data?.status)
        setLoader(false)
    }

    useEffect(() => {
        scoreBoard()
    }, [type])



    return (
        <>
            {(loader ? <Loader /> :
                <div className='scoreboard-container '  style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                    <div className='container scoreboard-bg'>
                        <div className=''>
                            <div className='container-nav-bar'>
                                <div className='nav-bar'>
                                    <div className='back-arrow'>

                                        <div className='back-arrow-button' onClick={() => gotoHome()}>
                                            {/* <p className="arrow left"></p> */}
                                            <img src={backArrow}></img>
                                        </div>
                                    </div>

                                    <div className='header-hosted-page'>Classement</div>
                                    {/* <div className='logo-div'><img className='logo' src={logo} /> </div> */}

                                </div>
                            </div>
                            <div className='w-[98%] flex justify-center  border-2 py-1 mx-auto border-[#FFCC00] rounded-md px-2 mt-2'>
                              <div className={`w-1/2 text-center cursor-pointer py-1 rounded-md ${type === "daily" ? "bg-black text-[#FFCC00]" : "text-black"}`} onClick={()=>setType("daily")}>
                                    Quotidien
                                 </div>
                                 
                                 <div className={`w-1/2 text-center cursor-pointer py-1 rounded-md px-2 ${type === "weekly" ? "bg-black text-[#FFCC00]" : "text-black"}`} onClick={()=>setType("weekly")}>
                                    Hebdomadaire
                                 </div>
                                 
                                 <div className={`w-1/2 text-center cursor-pointer py-1 rounded-md ${type === "monthly" ? "bg-black text-[#FFCC00]" : "text-black"}`} onClick={()=>setType("monthly")}>
                                    Mensuel
                                 </div>
                            </div>
                           
                           {(sbData && status !== "failed" && sbData.length !== 0) && <div className='w-full md:min-h-[40vh] min-h-[45vh] flex justify-around px-4' style={{ backgroundImage: `url(${bg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
 

  {[2, 0, 1].map((orderIndex, i) => {
    const user = sbData[orderIndex];
    if (!user) return null;

    return (
      <div key={orderIndex} className={`items-center ${orderIndex === 0 ? 'mt-2' : 'md:mt-32 mt-40'}`}>
        {orderIndex === 0 && <img src={crown} className='md:w-[90px] md:ml-2 w-[80px] ml-3'></img>}
      <img src={orderIndex === 0 ? position1 : orderIndex === 1 ? position2 : position3} className={orderIndex === 0 ? 'h-20' : 'h-16'} />
      <div className={`text-${orderIndex === 2 ? 'lg' : 'base'} ${user.userId === msisdn ? 'text-[#00678F] ' : ' text-black'} font-semibold `}>{changeToStar(user.userId)}</div>
      <div className={`text-${orderIndex === 2 ? 'lg' : 'base'}  ${user.userId === msisdn ? 'text-[#00678F] ' : ' text-black'} px-1`}>{user.score} score</div>
    </div>
    );
  })}
</div>}


                            <div className='hosted-page-body  w-full mx-auto'>
                                <div className='flex py-2 header-text rounded-t-md px-2 justify-between'>
                                    <div className=''>Classement</div>
                                    <div className=''>SCORE</div>
                                    <div className=''>MSISDN</div>
                                </div>

                  

{!sbData || status === "failed" || sbData.length === 0 ? <div>

<div className='w-full mt-4'>
  <img src={nodata} className='w-[30%] mx-auto'></img>
  <h1 className='text-center w-[90%] mx-auto mt-4'>Actuellement, aucun gagnant n'est disponible. Restez à 
l'écoute pour les prochains résultats !</h1>
<div className='w-[90%] mx-auto cursor-pointer' onClick={()=>navigate("/home")}>
<button className='w-full border-1 mt-6 bg-[#FFCC00] px-2 py-3 rounded-xl text-black font-semibold'>d'accord</button>
</div>
  </div>
</div> : (
<>
{
    (() => {
      const restUsers = sbData.slice(3); // all below top 3
      const currentUser = restUsers.find(user => user.userId === msisdn);
      const others = restUsers.filter(user => user.userId !== msisdn);

      // Combine with current user on top if found
      const reordered = currentUser ? [currentUser, ...others] : others;

      return reordered.map((data, index) => (
        <div
          key={data.userId}
          className={`grid py-4 px-1 mt-1 rounded-sm ${
            data.userId === msisdn ? 'bg-[#00678F] text-white' : 'bg-white text-black'
          }`}
        >
           <div className='content-text flex'>
            <img src={rankIcon} className='w-7 h-7 pr-2' />
            {/* Display original rank from sbData */}
            {/* {sbData.findIndex(item => item.userId === data.userId) + 1} */}
            <h1 className={`${data.userId === msisdn ? "text-white" : "text-black"}`}>{data.id}</h1>
          </div>
          <div className={`content-text content-center ${data.userId === msisdn ? "text-white" : "text-black"}`}>{data.score}</div>
          <div className={`content-text ${data.userId === msisdn ? "text-white" : "text-black"}`}>{changeToStar(data.userId)}</div>
        </div>
      ));
    })()
  }
  </>)}



                            </div>



                        </div>
                    </div>
                </div>)}
        </>
    )
}